export default "__VITE_ASSET__CViOi_dy__"